import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getThemeByType } from '../themes';

const ThemeLayout = ({ children, themeType = 'light' }) => {
    const theme = getThemeByType(themeType);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default ThemeLayout;